/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisionHistoryItem } from './RevisionHistoryItem';
import {
    RevisionHistoryItemFromJSON,
    RevisionHistoryItemFromJSONTyped,
    RevisionHistoryItemToJSON,
    RevisionHistoryItemToJSONTyped,
} from './RevisionHistoryItem';

/**
 * 
 * @export
 * @interface RevisionHistoryResponse
 */
export interface RevisionHistoryResponse {
    /**
     * 
     * @type {Array<RevisionHistoryItem>}
     * @memberof RevisionHistoryResponse
     */
    revisionHistoryItems: Array<RevisionHistoryItem>;
}

/**
 * Check if a given object implements the RevisionHistoryResponse interface.
 */
export function instanceOfRevisionHistoryResponse(value: object): value is RevisionHistoryResponse {
    if (!('revisionHistoryItems' in value) || value['revisionHistoryItems'] === undefined) return false;
    return true;
}

export function RevisionHistoryResponseFromJSON(json: any): RevisionHistoryResponse {
    return RevisionHistoryResponseFromJSONTyped(json, false);
}

export function RevisionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'revisionHistoryItems': ((json['revisionHistoryItems'] as Array<any>).map(RevisionHistoryItemFromJSON)),
    };
}

export function RevisionHistoryResponseToJSON(json: any): RevisionHistoryResponse {
    return RevisionHistoryResponseToJSONTyped(json, false);
}

export function RevisionHistoryResponseToJSONTyped(value?: RevisionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'revisionHistoryItems': ((value['revisionHistoryItems'] as Array<any>).map(RevisionHistoryItemToJSON)),
    };
}

